import { useMemo } from 'react';

import { INBOUND_REFERRALS_ROUTES } from 'components/inboundReferrals/constants';
import { Flags } from 'constants/flags';
import { useProfile } from 'context/profile';
import Profile, { PERMISSIONS, PRODUCT_ACCESSORS } from 'models/Profile';

const getDefaultRedirect = (profile: Profile) => {
  const careCoordinationEnabled = profile.has(PRODUCT_ACCESSORS.careCoordinationEnabled);
  const olioSummarizationEnabled = profile.has(PRODUCT_ACCESSORS.olioSummarizationEnabled);
  const inboundReferralsEnabled =
    profile.has(PRODUCT_ACCESSORS.inboundReferralsEnabled) && profile.hasFlag(Flags.InboundReferrals);

  if (careCoordinationEnabled) return '/patients';
  if (olioSummarizationEnabled) return '/summarizations/new';
  if (inboundReferralsEnabled) return INBOUND_REFERRALS_ROUTES.BASE;
  // An admin acting as a client with no products on would otherwise be stuck on /error, since the
  // acting client persists across logins. The admin-client-view check also keeps this from looping:
  // /admin/clients is gated on it and falls back here when it fails.
  if (profile.isAdmin && profile.has(PERMISSIONS.adminClientView)) return '/admin/clients';

  return '/error';
};

export default function useDefaultRedirect() {
  const { profile } = useProfile();

  const redirectTo = useMemo(() => getDefaultRedirect(profile), [profile]);

  return redirectTo;
}
